'use client';

import React from 'react';

import classNames from 'classnames';
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useAuth } from '@shared/common/providers/AuthProvider';
import {
  useRewardPoolsStatsQuery,
  useSelfRewardPoolStatsQuery,
} from '@shared/hooks/query/rewardPools';

const RewardPoolsStats = ({ className }: { className?: string }) => {
  const { isAuth } = useAuth();
  const { data: statsData } = useRewardPoolsStatsQuery();
  const { data: selfStatsData } = useSelfRewardPoolStatsQuery({
    enabled: isAuth,
  });

  const stats = [
    {
      id: 'total-sqr-distributes',
      label: 'Total $SQR Distributed',
      content: statsData?.totalSqr,
    },
    // {
    //   id: 'total-sqrp-distributed',
    //   label: 'Total SQRp Distributed',
    //   content: '250,456',
    // },
    {
      id: 'total-karma-distributed',
      label: 'Total Karma Distributed',
      content: statsData?.totalKarma,
    },
    {
      id: 'total-pools-started',
      label: 'Pools Started',
      content: statsData?.poolsStarted,
    },
    {
      id: 'total-participants',
      label: 'Total Participants',
      content: statsData?.totalParticipants,
    },
    {
      id: 'pools-available',
      label: 'Pools Available',
      content: statsData?.totalParticipants,
    },
    {
      id: 'sqr-reward-available',
      label: '$SQR Reward Available',
      content: statsData?.sqrAvailable,
    },
    // {
    //   id: 'sqrp-reward-available',
    //   label: 'SQRp Reward Available',
    //   content: '54,546',
    // },
    // {
    //   id: 'loot-boxes-available',
    //   label: 'Loot Boxes Available',
    //   content: '50',
    // },
    {
      id: 'sqr-claimed-by-me',
      label: '$SQR Claimed by Me',
      content: selfStatsData?.mySqr,
    },
    // {
    //   id: 'sqrp-claimed-by-me',
    //   label: '$SQRp Claimed by Me',
    //   content: '250,456',
    // },
    {
      id: 'karma-claimed-by-me',
      label: 'Karma Claimed by Me',
      content: selfStatsData?.myKarma,
    },
    // {
    //   id: 'loot-boxes-claimed-by-me',
    //   label: 'Loot Boxes Claimed by Me',
    //   content: '15,000,000',
    // },
    {
      id: 'pools-joined-by-me',
      label: 'Pools Joined by Me',
      content: selfStatsData?.poolsJoined,
    },
  ];

  return (
    <Swiper
      className={classNames(
        'pb-[2.25rem] mb-8 xl:mb-14 xl:pb-10 -mx-4 max-md:px-4 md:-mx-2 line-swiper-pagination',
        className,
      )}
      modules={[Pagination, Autoplay]}
      pagination={{
        enabled: true,
        clickable: true,
      }}
      autoplay={{
        delay: 5000,
        pauseOnMouseEnter: true,
      }}
      slidesPerView="auto"
    >
      {stats.map((stat) => (
        <SwiperSlide
          key={stat.id}
          className="select-none px-1 w-full sm:w-1/2 lg:w-1/3 md:px-2 xl:w-1/4 max-md:first:pl-0 max-md:last:pr-0"
        >
          <p className="p-6 flex flex-col gap-2 rounded-xl border border-[#E7E7EF]">
            <span className="font-medium leading-6 text-[#373743]">{stat.label}</span>
            <span className="font-semibold text-[#09090B] text-2xl">
              {typeof stat.content !== 'number' ? '—' : stat.content}
            </span>
          </p>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default RewardPoolsStats;
